import constants from './constants';

export const TrackingUtil = {

    /**
     * @param id the product id
     * @param ts timestamp
     * @param rnd a random number
     */
    throwClickout: function (id, ts, rnd, uuid, location, index) {
        this.throwCustomEvent({
            type: constants.TRACK_CLICKOUT,
            productId: id,
            timestamp: ts,
            random: rnd,
            productUuid: uuid,
            location: location
        });
    },

    /**
     * @param uuid the product uuid
     */
    throwProductLike: function (uuid) {
        this.throwCustomEvent({
            type: constants.TRACK_PRODUCTLIKE,
            productUuid: uuid
        });
    },
    /**
     * throws a custom event
     * @param data custom event data
     */
    throwCustomEvent: function (data) {
        const customEvent = document.createEvent('Event');
        customEvent.initEvent(data.type, true, true);
        if (data != null) {
            customEvent.data = data;
        }
        document.getElementById('body').dispatchEvent(customEvent);
    },

    throwGAEvent: function (category, action, label, nonInteractive) {
        const gaEvent = document.createEvent('Event');
        gaEvent.initEvent(constants.TRACK_GA_EVENT, true, true);
        const data = {
            category: category,
            action: action,
            label: label,
            nonInteractive: nonInteractive
        };

        gaEvent.data = data;
        document.getElementById('body').dispatchEvent(gaEvent);
    },

    throwGAPageview: function(page) {
        const gaPageview = document.createEvent('Event');
        gaPageview.initEvent(constants.TRACK_GA_PAGEVIEW, true, true);
        const data = {
            page: page
        };

        gaPageview.data = data;
        document.getElementById('body').dispatchEvent(gaPageview);
    },

    throwUserAuthenticationEvent: function (action, authMode) {
        return new Promise((resolve) => {
            this.throwGAEvent('User', action, authMode, false);
            resolve();
        });
    },

    throwFilterClickedEvent: function(filterType, filterValue) {
        this.throwCustomEvent({
            type: constants.TRACK_FILTER_CLICKED_EVENT,
            filterType: filterType,
            filterValue: filterValue
        });
    },

    throwSimilarBrandsClickedEvent: function(brandId, brandName) {
        this.throwCustomEvent( {
            type: constants.TRACK_SIMILAR_BRANDS_CLICKED_EVENT,
            brandId: brandId,
            brandName: brandName
        });
    },

    throwFilterSuggestionsViewEvent: function(action) {
        this.throwCustomEvent({
            type: constants.TRACK_FILTER_SUGGESTIONS,
            action: action,
            label: '',
            nonInteractive: true
        })
    },

    throwFilterSuggestionsClickEvent: function(action, url, filterSuggestionId, filterSuggestionType) {
        this.throwCustomEvent({
            type: constants.TRACK_FILTER_SUGGESTIONS,
            action: action,
            label: url,
            nonInteractive: false,
            filterSuggestionId: filterSuggestionId,
            filterSuggestionType: filterSuggestionType
        })
    },

    throwQuickviewOpenEvent: function(productId, productUuid, priceComparisonView) {
        if(priceComparisonView) {
            this.throwGAPageview('/Virtual/QuickviewPC/');
        } else {
            this.throwGAPageview('/Virtual/Quickview/');
        }

        this.throwCustomEvent({
            type: constants.TRACK_QUICK_VIEW_OPEN_EVENT,
            productId: productId,
            productUuid: productUuid
        })
    }
};
